var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-breadcrumb',{attrs:{"page-title":_vm.$t('form_validations'),"directory":_vm.$t('forms_and_fields'),"icon":'sidebar'}}),_vm._v(" "),_c('form-validation-required',{staticClass:"mb-primary"}),_vm._v(" "),_c('form-validation-range')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }